export const Header = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 py-4 px-6 bg-background/80 backdrop-blur-md border-b border-border/30">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        {/* Logo and branding */}
        <a
          href="https://layout.dev"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 group transition-all hover:scale-105"
        >
          <img 
            src="/layout-logo.svg" 
            alt="Layout.dev Logo" 
            className="h-8 w-auto transition-transform group-hover:rotate-3"
          />
          <div className="flex flex-col">
            <span className="text-xs text-muted-foreground">Powered by</span>
            <span className="text-base font-bold bg-gradient-to-r from-primary via-secondary to-accent bg-clip-text text-transparent">
              Layout.dev
            </span>
          </div>
        </a>

        {/* Optional: Navigation or CTA */}
        <div className="hidden md:flex items-center gap-4">
          <a
            href="https://layout.dev"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-muted-foreground hover:text-accent transition-colors"
          >
            Try Layout.dev
          </a>
        </div>
      </div>
    </header>
  );
};
